module.exports = require("@trendmicro/react-portal");